(function () {
  if (customElements.get('set-multiplier')) return;

  const EN_FAZLA_GIRIS = 9999;
  const KACIS = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' };

  class SetMultiplier extends HTMLElement {
    connectedCallback() {
      const configNode = this.querySelector('[data-set-config]');
      if (!configNode) return;
      try {
        this.config = JSON.parse(configNode.textContent);
      } catch (e) {
        return;
      }
      this.form = document.getElementById(this.getAttribute('form'));
      if (!this.form || !this.config.variants || !this.config.variants.length) return;

      this.sectionId = this.getAttribute('data-section-id');
      this.productId = this.getAttribute('data-product-id');
      this.dist = this.config.dist.map((d) => ({ k: d.size, q: d.qty }));
      this.birim = this.dist.reduce((toplam, h) => toplam + h.q, 0);
      this.toptanKalan = Number(this.dataset.toptanKalan) || 1000;
      this.distNode = this.querySelector('[data-set-dist]');
      this.noteNode = this.querySelector('[data-set-note]');
      this.statusNode = this.querySelector('[data-set-status]');
      this.summaryNode = this.querySelector('[data-set-summary]');
      this.cartItems = null;
      this.busy = false;
      this.planlanan = null;
      this.initialInCart = this.config.inCart || 0;

      const initial = this.variantById(this.config.currentId) || this.config.variants[0];
      this.initialOptions = initial.options;
      this.currentVariant = this.variantById(this.form.querySelector('[name="id"]')?.value) || initial;

      this.onSubmit = this.onSubmit.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onQuantityChange = this.onQuantityChange.bind(this);
      this.onCartUpdate = this.onCartUpdate.bind(this);
      this.onQuantityBoundries = this.onQuantityBoundries.bind(this);

      this.form.addEventListener('submit', this.onSubmit, true);
      this.form.addEventListener('variant:change', this.onVariantChange);
      document.addEventListener('change', this.onQuantityChange);
      document.addEventListener('input', this.onQuantityChange);
      this.unsubscribeCart = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
      this.unsubscribeBoundries = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.quantityBoundries, this.onQuantityBoundries);

      this.refresh();
      this.loadCart();
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('submit', this.onSubmit, true);
        this.form.removeEventListener('variant:change', this.onVariantChange);
      }
      document.removeEventListener('change', this.onQuantityChange);
      document.removeEventListener('input', this.onQuantityChange);
      if (this.unsubscribeCart) this.unsubscribeCart();
      if (this.unsubscribeBoundries) this.unsubscribeBoundries();
    }

    get dagitim() {
      return window.SetDagitim || null;
    }

    get quantityInput() {
      return this.form ? this.form.elements.namedItem('quantity') : null;
    }

    get submitButtons() {
      const id = this.form.getAttribute('id');
      return Array.from(document.querySelectorAll(`#${CSS.escape(id)} [type="submit"], [type="submit"][form="${id}"]`));
    }

    get stickyForm() {
      return document.getElementById(`ProductStickyForm-${this.sectionId}-${this.productId}`);
    }

    get picker() {
      return document.getElementById(`VariantPicker-${this.sectionId}-${this.productId}`);
    }

    variantById(id) {
      if (!id) return null;
      const numeric = parseInt(id);
      return this.config.variants.find((v) => v.id === numeric) || null;
    }

    comboOf(options) {
      return this.config.visible.map((p) => options[p - 1]);
    }

    sameCombo(a, b) {
      return this.config.visible.every((p) => a[p - 1] === b[p - 1]);
    }

    keyOf(options) {
      let key = String(options[this.config.sizeIndex]).toUpperCase();
      const lenIndex = this.config.lenIndex;
      if (typeof lenIndex === 'number' && lenIndex >= 0) key += '/' + String(options[lenIndex]).replace(',', '.');
      return key;
    }

    labelOf(key) {
      return String(key).replace('.', ',');
    }

    escape(text) {
      return String(text).replace(/[&<>"]/g, (c) => KACIS[c]);
    }

    analyze(options) {
      const D = this.dagitim;
      if (!D) return null;

      const hucreler = this.dist.map((h) => {
        const variant = this.config.variants.find((v) => this.keyOf(v.options) === h.k && this.sameCombo(v.options, options)) || null;
        return { k: h.k, q: h.q, variant, stok: variant ? D.stokDegeri(variant.stock) : 0 };
      });
      const stok = {};
      hucreler.forEach((h) => {
        stok[h.k] = h.stok;
      });

      const maxSets = D.enFazlaSet(this.dist, stok, this.config.esik || 0);

      let parca;
      const sepetAdet = {};
      if (this.cartItems) {
        const idler = new Set(hucreler.filter((h) => h.variant).map((h) => h.variant.id));
        parca = 0;
        this.cartItems.forEach((item) => {
          if (!idler.has(item.variant_id)) return;
          parca += item.quantity;
          sepetAdet[item.variant_id] = (sepetAdet[item.variant_id] || 0) + item.quantity;
        });
      } else {
        parca = this.sameCombo(options, this.initialOptions) ? this.initialInCart * this.birim : 0;
      }

      const inCart = this.birim > 0 ? Math.floor(parca / this.birim) : 0;
      const remaining = maxSets >= D.SINIRSIZ ? D.SINIRSIZ : Math.max(0, maxSets - inCart);
      return { hucreler, stok, maxSets, inCart, remaining, sepetAdet };
    }

    plan(a, sets) {
      const D = this.dagitim;
      if (!D || !a || sets < 1) return null;
      const hedef = D.toplam(this.dist, a.stok, a.inCart + sets);
      const onceki = D.toplam(this.dist, a.stok, a.inCart);
      if (!hedef || !onceki) return null;

      const eklenecek = {};
      let price = 0;
      let sapma = false;
      a.hucreler.forEach((h) => {
        const adet = hedef[h.k] - onceki[h.k];
        eklenecek[h.k] = adet;
        if (adet !== h.q * sets) sapma = true;
        if (h.variant) price += adet * Math.round(h.variant.price * this.toptanKalan / 1000);
      });
      return { sets, hedef, eklenecek, price, sapma };
    }

    sets() {
      const input = this.quantityInput;
      const value = input ? parseInt(input.value) : 1;
      if (isNaN(value) || value < 1) return 1;
      return Math.min(value, EN_FAZLA_GIRIS);
    }

    hesapla() {
      const a = this.analysis;
      const D = this.dagitim;
      if (!a || !D || a.remaining < 1) {
        this.planlanan = null;
        return;
      }
      const sinir = a.remaining >= D.SINIRSIZ ? EN_FAZLA_GIRIS : a.remaining;
      this.planlanan = this.plan(a, Math.min(this.sets(), sinir));
    }

    refresh() {
      if (!this.currentVariant) return;
      this.analysis = this.analyze(this.currentVariant.options);
      if (!this.analysis) return;
      this.renderStatus();
      this.applyLimits();
      this.hesapla();
      this.renderDist();
      this.renderSummary();
      this.markOptions();
      this.updateSticky();
    }

    renderStatus() {
      if (!this.statusNode) return;
      const a = this.analysis;
      const D = this.dagitim;
      let text;
      let error = false;
      if (a.maxSets < 1) {
        text = 'Bu seçim için stok tükendi';
        error = true;
      } else if (a.maxSets >= D.SINIRSIZ) {
        text = 'Stokta';
      } else if (a.remaining < 1) {
        text = `Stoktaki ${a.maxSets} setin tamamı sepetinizde`;
      } else {
        text = `Stokta ${a.maxSets} set${a.inCart > 0 ? ` · Sepette ${a.inCart} set` : ''}`;
      }
      this.statusNode.textContent = text;
      this.statusNode.classList.toggle('set-multiplier__status--error', error);
    }

    renderDist() {
      if (!this.distNode) return;
      const p = this.planlanan;
      this.distNode.innerHTML = this.dist
        .map((h) => {
          const adet = p ? p.eklenecek[h.k] : h.q;
          const sinif = p && adet === 0 ? ' set-multiplier__chip--yok' : '';
          return `<span class="set-multiplier__chip${sinif}">${this.escape(this.labelOf(h.k))} × ${adet}</span>`;
        })
        .join('');
      if (this.noteNode) this.noteNode.hidden = !(p && p.sapma);
    }

    renderSummary() {
      if (!this.summaryNode) return;
      const p = this.planlanan;
      if (!p) {
        this.summaryNode.hidden = true;
        return;
      }
      const pieces = p.sets * this.birim;
      let money = '';
      if (!this.hasAttribute('data-fiyat-gizli') && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        money = theme.Currency.formatMoney(p.price, theme.settings.moneyFormat);
      }
      this.summaryNode.hidden = false;
      this.summaryNode.innerHTML = `Sepete eklenecek: ${p.sets} set = ${pieces} adet${money ? ` · ${money}` : ''}`;
    }

    applyLimits() {
      const a = this.analysis;
      const D = this.dagitim;
      const input = this.quantityInput;
      const canAdd = a.remaining >= 1;

      if (input) {
        if (a.remaining >= D.SINIRSIZ) {
          input.removeAttribute('max');
        } else {
          input.setAttribute('max', String(a.remaining));
          if (a.remaining >= 1 && parseInt(input.value) > a.remaining) input.value = String(a.remaining);
        }
        if (isNaN(parseInt(input.value)) || parseInt(input.value) < 1) input.value = '1';
        const wrapper = input.closest('quantity-input');
        if (wrapper && typeof wrapper.validateQtyRules === 'function') wrapper.validateQtyRules();
      }

      const text = a.maxSets < 1 ? theme.variantStrings.soldOut : 'Stok yetersiz';
      [this.form, this.stickyForm].forEach((form) => {
        if (!form || typeof form.toggleSubmitButton !== 'function') return;
        if (canAdd) {
          form.toggleSubmitButton(false);
        } else {
          form.toggleSubmitButton(true, text);
        }
      });
    }

    markOptions() {
      const picker = this.picker;
      if (!picker || !this.currentVariant) return;
      picker.querySelectorAll('input[type="radio"][data-option-index]').forEach((input) => {
        const position = parseInt(input.getAttribute('data-option-index'));
        if (!this.config.visible.includes(position)) return;
        const options = this.currentVariant.options.slice();
        options[position - 1] = input.value;
        const sonuc = this.analyze(options);
        input.classList.toggle('disabled', !sonuc || sonuc.maxSets < 1);
      });
    }

    updateSticky() {
      const sticky = this.stickyForm;
      if (!sticky) return;
      const node = sticky.querySelector('[data-sticky-product-options]');
      if (!node) return;
      const text = this.comboOf(this.currentVariant.options).filter(Boolean).join(' / ');
      setTimeout(() => {
        node.innerText = text;
      }, 0);
    }

    onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      this.currentVariant = this.variantById(variant.id) || {
        id: variant.id,
        options: variant.options || [variant.option1, variant.option2, variant.option3],
        stock: null,
        price: variant.price
      };
      this.refresh();
    }

    onQuantityChange(event) {
      if (!event.target || event.target !== this.quantityInput || !this.analysis) return;
      this.hesapla();
      this.renderDist();
      this.renderSummary();
    }

    onCartUpdate(event) {
      if (event && event.cart && event.cart.items) this.cartItems = event.cart.items;
      this.refresh();
    }

    onQuantityBoundries(event) {
      const data = event && event.data;
      if (!data || data.sectionId !== this.sectionId || String(data.productId) !== String(this.productId)) return;
      setTimeout(() => {
        if (!this.analysis) return;
        this.applyLimits();
        this.hesapla();
        this.renderDist();
        this.renderSummary();
      }, 0);
    }

    loadCart() {
      fetch(`${theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && cart.items) {
            this.cartItems = cart.items;
            this.refresh();
          }
        })
        .catch(() => {});
    }

    notify(message) {
      const node = this.querySelector('[data-set-notice]');
      if (!node) return;
      node.textContent = message;
      node.hidden = false;
      clearTimeout(this.noticeTimer);
      this.noticeTimer = setTimeout(() => {
        node.hidden = true;
      }, 4000);
    }

    showError(message) {
      if (typeof this.form.handleErrorMessage === 'function') this.form.handleErrorMessage(message);
    }

    validate(a, sets) {
      const D = this.dagitim;
      if (a.maxSets < 1) return 'Bu seçim için stok tükendi.';
      if (a.remaining < D.SINIRSIZ && sets > a.remaining) {
        return a.remaining < 1 ? 'Bu seçim için stoktaki tüm setler zaten sepetinizde.' : `En fazla ${a.remaining} set ekleyebilirsiniz.`;
      }
      return null;
    }

    onSubmit(event) {
      if (event.target !== this.form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (theme.settings.orderingLocked) {
        window.location.href = theme.settings.loginUrl;
        return;
      }
      if (this.busy) return;
      if (this.form.submitButton && this.form.submitButton.hasAttribute('aria-disabled')) return;

      const a = this.currentVariant ? this.analyze(this.currentVariant.options) : null;
      if (!a) {
        this.showError('Set bilgisi yüklenemedi. Sayfayı yenileyip tekrar deneyin.');
        return;
      }
      this.analysis = a;
      const sets = this.sets();
      const error = this.validate(a, sets);
      if (error) {
        this.showError(error);
        return;
      }
      const p = this.plan(a, sets);
      if (!p) {
        this.showError('Set dağılımı hesaplanamadı. Sayfayı yenileyip tekrar deneyin.');
        return;
      }

      const updates = {};
      a.hucreler.forEach((h) => {
        if (!h.variant) return;
        const hedef = p.hedef[h.k] || 0;
        if (hedef > 0 || a.sepetAdet[h.variant.id] > 0) updates[h.variant.id] = hedef;
      });

      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

      const config = theme.utils.fetchConfig();
      config.body = JSON.stringify({ updates, sections: sections.join(','), sections_url: window.location.pathname });

      this.showError(false);
      this.busy = true;
      const buttons = this.submitButtons;
      buttons.forEach((button) => {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
      });

      fetch(theme.routes.cart_update_url, config)
        .then((response) => response.json())
        .then((parsed) => {
          if (parsed.status) {
            const message = parsed.description || parsed.message;
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: this.currentVariant.id,
              errors: parsed.errors || parsed.description,
              message: parsed.message
            });
            this.showError(message);
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: message } }));
            return;
          }

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: this.currentVariant.id, cart: parsed });
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));

          if (theme.settings.cartType === 'page' || document.body.classList.contains('template-cart')) {
            window.location.href = theme.routes.cart_url;
            return;
          }
          this.notify(`${p.sets} set (${p.sets * this.birim} adet) sepete eklendi`);
        })
        .catch((error) => {
          console.error(error);
          this.showError('Sepet güncellenemedi. Tekrar deneyin.');
        })
        .finally(() => {
          this.busy = false;
          buttons.forEach((button) => {
            button.removeAttribute('aria-busy');
            button.removeAttribute('aria-disabled');
          });
        });
    }
  }

  customElements.define('set-multiplier', SetMultiplier);
})();
